import { Session } from "../../../api/session";
import { ManagedSessionFactory } from "./managed-session-factory";
import { ManagedSession } from "./managed-session";
import { SessionManager } from "./session-manager";

/**
 * Function which returns a ManagedSessionFactory.
 * @public
 */
export function defaultManagedSessionFactory(): ManagedSessionFactory {
  return (sessionManager: SessionManager, session: Session): ManagedSession => {
    return { session, held: false, muted: false };
  };
}
